import script from "./HomeInfoComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeInfoComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomeInfoComponent.vue?vue&type=style&index=0&id=22fdf52f&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22fdf52f"]])

export default __exports__